/* eslint-disable @typescript-eslint/no-unused-vars, react-hooks/exhaustive-deps */
import { Avatar, Box, Link, SxProps } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useAuthResult } from "../app/auth";
import Config from "../config";

const ChildProfileImageUploader = (props: { childId: number; sx?: SxProps }) => {
  const { childId, sx } = props;
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const auth = useAuthResult();

  // Construct image URL from known blob name convention
  const getImageUrl = () => `${Config.api.uri}/children/${childId}.jpg`;

  // Try to load image (only triggers on mount or childId change)
  useEffect(() => {
    setImageUrl(getImageUrl());
  }, [childId]);

  const handleImageClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setIsUploading(true);

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("childId", childId.toString());

      const response = await fetch(`${Config.api.uri}/children/profileimage`, {
        method: "POST",
        body: formData,
        headers: { Authorization: `Bearer ${auth?.accessToken}`, "X-Auth-Scheme": "Session" },
      });

      if (!response.ok) {
        throw new Error("Upload failed");
      }

      // Optionally get the new image URL from response
      const { Url } = await response.json();

      // Bust cache by appending a timestamp
      setImageUrl(`${getImageUrl()}?t=${Date.now()}`);
    } catch (err) {
      console.error(err);
      alert("Failed to upload image");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    // <Avatar alt="child picture" variant="circular" src={sampleChild} sx={{ width: 180, height: 180 }} />
    <Box style={{ textAlign: "center" }} sx={sx}>
      <input type="file" accept="image/*" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} />

      <Avatar
        alt="child picture"
        variant="circular"
        src={imageUrl || ""}
        sx={{ width: 180, height: 180, objectFit: "cover", cursor: "pointer", transition: "opacity 0.3s", opacity: isUploading ? 0.5 : 1 }}
        onClick={handleImageClick}
      />

      <Link sx={{ mt: 3, cursor: "pointer" }} onClick={handleImageClick} underline="hover">
        {isUploading ? "Uploading..." : "Change image"}
      </Link>
    </Box>
  );
};

export default ChildProfileImageUploader;
